import script from "./profitAndLoss.vue?vue&type=script&setup=true&lang=js"
export * from "./profitAndLoss.vue?vue&type=script&setup=true&lang=js"

import "./profitAndLoss.vue?vue&type=style&index=0&id=35fb2054&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35fb2054"]])

export default __exports__